<div class="c-form__message">
    <h3 class="c-heading c-heading--small">{ title }</h3>
    <a class="c-link u-text-small" href="{ actionLink }">{ actionText }</a>
</div>

<script>

    export default {

        data() {
            return {
                title: '',
                actionText: '',
                actionLink: '',
            };
        },

    }
</script>